import {
  Company,
  Customer,
  Invoice,
  LineItem,
  Subscription,
  Payment,
  Refund,
} from '../types'
import {
  calculateStripeFee,
  calculateNetAmount,
  calculateProfitMargin,
} from './calculations'

// Current date: December 9, 2025
const TODAY = new Date('2025-12-09')

export const companies: Company[] = [
  { id: 'wf', name: 'WebsiteForge', stripe_key: 'sk_test_web123' },
  {
    id: 'mip',
    name: 'Mission Impossible Printing',
    stripe_key: 'sk_test_print456',
  },
  { id: 'st', name: 'Storm Taekwondo', stripe_key: 'sk_test_taek789' },
]

// WebsiteForge Customers
const wfCustomers: Customer[] = [
  {
    id: 'wf-cust-1',
    company_id: 'wf',
    name: 'John Doe',
    email: 'john@techstartup.com',
    address: '123 Main St, Detroit, MI 48201',
    phone: '555-0101',
    stripe_customer_id: 'cus_web1',
    terms_accepted: true,
  },
  {
    id: 'wf-cust-2',
    company_id: 'wf',
    name: 'Sarah Miller',
    email: 'sarah@millerconsulting.com',
    address: '456 Oak Ave, Ann Arbor, MI 48104',
    phone: '555-0102',
    stripe_customer_id: 'cus_web2',
    terms_accepted: true,
  },
  {
    id: 'wf-cust-3',
    company_id: 'wf',
    name: 'Tech Solutions LLC',
    email: 'contact@techsolutions.io',
    address: '789 Innovation Dr, Troy, MI 48083',
    phone: '555-0103',
    stripe_customer_id: 'cus_web3',
    terms_accepted: true,
  },
  {
    id: 'wf-cust-4',
    company_id: 'wf',
    name: 'Emily Chen',
    email: 'emily@chendesigns.com',
    address: '321 Maple Rd, Birmingham, MI 48009',
    phone: '555-0104',
    stripe_customer_id: 'cus_web4',
    terms_accepted: false,
  },
  {
    id: 'wf-cust-5',
    company_id: 'wf',
    name: 'Downtown Cafe',
    email: 'orders@downtowncafe.com',
    address: '555 Woodward Ave, Detroit, MI 48226',
    phone: '555-0105',
    stripe_customer_id: 'cus_web5',
    terms_accepted: true,
  },
]

// Mission Impossible Printing Customers
const mipCustomers: Customer[] = [
  {
    id: 'mip-cust-1',
    company_id: 'mip',
    name: 'Metro Real Estate',
    email: 'print@metrorealestate.com',
    address: '100 Commerce Blvd, Southfield, MI 48075',
    phone: '555-0201',
    stripe_customer_id: 'cus_print1',
    terms_accepted: true,
  },
  {
    id: 'mip-cust-2',
    company_id: 'mip',
    name: 'Lakeside Restaurant',
    email: 'manager@lakesiderest.com',
    address: '200 Lake Shore Dr, St. Clair Shores, MI 48080',
    phone: '555-0202',
    stripe_customer_id: 'cus_print2',
    terms_accepted: true,
  },
  {
    id: 'mip-cust-3',
    company_id: 'mip',
    name: 'Green Thumb Landscaping',
    email: 'info@greenthumbmi.com',
    address: '300 Garden Way, Livonia, MI 48150',
    phone: '555-0203',
    stripe_customer_id: 'cus_print3',
    terms_accepted: true,
  },
  {
    id: 'mip-cust-4',
    company_id: 'mip',
    name: 'Auto Excellence',
    email: 'service@autoexcellence.com',
    address: '400 Motor City Dr, Dearborn, MI 48124',
    phone: '555-0204',
    stripe_customer_id: 'cus_print4',
    terms_accepted: true,
  },
  {
    id: 'mip-cust-5',
    company_id: 'mip',
    name: 'Bright Smiles Dental',
    email: 'office@brightsmiles.com',
    address: '500 Health Park, Royal Oak, MI 48067',
    phone: '555-0205',
    stripe_customer_id: 'cus_print5',
    terms_accepted: false,
  },
]

// Storm Taekwondo Customers
const stCustomers: Customer[] = [
  {
    id: 'st-cust-1',
    company_id: 'st',
    name: 'The Johnson Family',
    email: 'johnsons@email.com',
    address: '111 Elm St, Canton, MI 48187',
    phone: '555-0301',
    stripe_customer_id: 'cus_taek1',
    terms_accepted: true,
  },
  {
    id: 'st-cust-2',
    company_id: 'st',
    name: 'Michael Park',
    email: 'mpark@email.com',
    address: '222 Pine Ave, Novi, MI 48375',
    phone: '555-0302',
    stripe_customer_id: 'cus_taek2',
    terms_accepted: true,
  },
  {
    id: 'st-cust-3',
    company_id: 'st',
    name: 'The Williams Family',
    email: 'williams.family@email.com',
    address: '333 Cedar Ln, Plymouth, MI 48170',
    phone: '555-0303',
    stripe_customer_id: 'cus_taek3',
    terms_accepted: true,
  },
  {
    id: 'st-cust-4',
    company_id: 'st',
    name: 'Jennifer Lee',
    email: 'jlee@email.com',
    address: '444 Birch Rd, Farmington Hills, MI 48331',
    phone: '555-0304',
    stripe_customer_id: 'cus_taek4',
    terms_accepted: true,
  },
  {
    id: 'st-cust-5',
    company_id: 'st',
    name: 'The Garcia Family',
    email: 'garcias@email.com',
    address: '555 Willow Way, Westland, MI 48185',
    phone: '555-0305',
    stripe_customer_id: 'cus_taek5',
    terms_accepted: false,
  },
]

export const customers: Customer[] = [
  ...wfCustomers,
  ...mipCustomers,
  ...stCustomers,
]

// WebsiteForge Line Items
const wfLineItems: LineItem[] = [
  // Invoice 1 - paid
  {
    id: 'wf-li-1',
    invoice_id: 'wf-inv-1',
    description: 'Web Design Package - Modern Blue Theme',
    quantity: 1,
    price: 1500,
    job_cost: 900,
    is_taxable: true,
    profit_margin: calculateProfitMargin(1500, 900),
  },
  {
    id: 'wf-li-2',
    invoice_id: 'wf-inv-1',
    description: 'SEO Optimization Setup',
    quantity: 1,
    price: 500,
    job_cost: 200,
    is_taxable: true,
    profit_margin: calculateProfitMargin(500, 200),
  },
  // Invoice 2 - paid
  {
    id: 'wf-li-3',
    invoice_id: 'wf-inv-2',
    description: 'E-commerce Website Development',
    quantity: 1,
    price: 3000,
    job_cost: 1800,
    is_taxable: true,
    profit_margin: calculateProfitMargin(3000, 1800),
  },
  {
    id: 'wf-li-4',
    invoice_id: 'wf-inv-2',
    description: 'Payment Gateway Integration',
    quantity: 1,
    price: 400,
    job_cost: 150,
    is_taxable: true,
    profit_margin: calculateProfitMargin(400, 150),
  },
  {
    id: 'wf-li-5',
    invoice_id: 'wf-inv-2',
    description: 'SSL Certificate (1 Year)',
    quantity: 1,
    price: 100,
    job_cost: 50,
    is_taxable: true,
    profit_margin: calculateProfitMargin(100, 50),
  },
  // Invoice 3 - paid
  {
    id: 'wf-li-6',
    invoice_id: 'wf-inv-3',
    description: 'Landing Page Design',
    quantity: 2,
    price: 750,
    job_cost: 400,
    is_taxable: true,
    profit_margin: calculateProfitMargin(750, 400),
  },
  // Invoice 4 - sent
  {
    id: 'wf-li-7',
    invoice_id: 'wf-inv-4',
    description: 'Website Maintenance (Monthly)',
    quantity: 1,
    price: 200,
    job_cost: 80,
    is_taxable: true,
    profit_margin: calculateProfitMargin(200, 80),
  },
  {
    id: 'wf-li-8',
    invoice_id: 'wf-inv-4',
    description: 'Content Updates',
    quantity: 3,
    price: 75,
    job_cost: 30,
    is_taxable: true,
    profit_margin: calculateProfitMargin(75, 30),
  },
  // Invoice 5 - sent
  {
    id: 'wf-li-9',
    invoice_id: 'wf-inv-5',
    description: 'Custom WordPress Theme',
    quantity: 1,
    price: 2500,
    job_cost: 1500,
    is_taxable: true,
    profit_margin: calculateProfitMargin(2500, 1500),
  },
  // Invoice 6 - sent
  {
    id: 'wf-li-10',
    invoice_id: 'wf-inv-6',
    description: 'Logo Design',
    quantity: 1,
    price: 800,
    job_cost: 300,
    is_taxable: true,
    profit_margin: calculateProfitMargin(800, 300),
  },
  {
    id: 'wf-li-11',
    invoice_id: 'wf-inv-6',
    description: 'Brand Guidelines Document',
    quantity: 1,
    price: 400,
    job_cost: 150,
    is_taxable: true,
    profit_margin: calculateProfitMargin(400, 150),
  },
  // Invoice 7 - draft
  {
    id: 'wf-li-12',
    invoice_id: 'wf-inv-7',
    description: 'Mobile App UI Design',
    quantity: 1,
    price: 4000,
    job_cost: 2400,
    is_taxable: true,
    profit_margin: calculateProfitMargin(4000, 2400),
  },
  // Invoice 8 - draft
  {
    id: 'wf-li-13',
    invoice_id: 'wf-inv-8',
    description: 'Website Audit & Report',
    quantity: 1,
    price: 350,
    job_cost: 100,
    is_taxable: true,
    profit_margin: calculateProfitMargin(350, 100),
  },
  // Invoice 9 - refunded
  {
    id: 'wf-li-14',
    invoice_id: 'wf-inv-9',
    description: 'Hosting Setup (Annual)',
    quantity: 1,
    price: 600,
    job_cost: 400,
    is_taxable: true,
    profit_margin: calculateProfitMargin(600, 400),
  },
  // Invoice 10 - voided
  {
    id: 'wf-li-15',
    invoice_id: 'wf-inv-10',
    description: 'Social Media Integration',
    quantity: 1,
    price: 300,
    job_cost: 100,
    is_taxable: true,
    profit_margin: calculateProfitMargin(300, 100),
  },
]

// Mission Impossible Printing Line Items
const mipLineItems: LineItem[] = [
  // Invoice 1 - paid
  {
    id: 'mip-li-1',
    invoice_id: 'mip-inv-1',
    description: 'Business Cards - Premium Matte',
    quantity: 500,
    price: 0.15,
    job_cost: 0.05,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.15, 0.05),
  },
  {
    id: 'mip-li-2',
    invoice_id: 'mip-inv-1',
    description: 'Letterhead - Full Color',
    quantity: 250,
    price: 0.25,
    job_cost: 0.1,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.25, 0.1),
  },
  // Invoice 2 - paid
  {
    id: 'mip-li-3',
    invoice_id: 'mip-inv-2',
    description: 'Flyers - 8.5x11 Glossy',
    quantity: 1000,
    price: 0.12,
    job_cost: 0.04,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.12, 0.04),
  },
  {
    id: 'mip-li-4',
    invoice_id: 'mip-inv-2',
    description: 'Brochures - Tri-fold',
    quantity: 500,
    price: 0.35,
    job_cost: 0.15,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.35, 0.15),
  },
  // Invoice 3 - paid
  {
    id: 'mip-li-5',
    invoice_id: 'mip-inv-3',
    description: 'Vinyl Banner - 3x6 ft',
    quantity: 2,
    price: 85,
    job_cost: 35,
    is_taxable: true,
    profit_margin: calculateProfitMargin(85, 35),
  },
  {
    id: 'mip-li-6',
    invoice_id: 'mip-inv-3',
    description: 'Yard Signs - 18x24',
    quantity: 10,
    price: 15,
    job_cost: 6,
    is_taxable: true,
    profit_margin: calculateProfitMargin(15, 6),
  },
  // Invoice 4 - sent
  {
    id: 'mip-li-7',
    invoice_id: 'mip-inv-4',
    description: 'Menu Printing - Laminated',
    quantity: 50,
    price: 4.5,
    job_cost: 1.8,
    is_taxable: true,
    profit_margin: calculateProfitMargin(4.5, 1.8),
  },
  // Invoice 5 - sent
  {
    id: 'mip-li-8',
    invoice_id: 'mip-inv-5',
    description: 'Door Hangers',
    quantity: 2000,
    price: 0.08,
    job_cost: 0.03,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.08, 0.03),
  },
  {
    id: 'mip-li-9',
    invoice_id: 'mip-inv-5',
    description: 'Postcards - 4x6',
    quantity: 1000,
    price: 0.1,
    job_cost: 0.04,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.1, 0.04),
  },
  // Invoice 6 - sent
  {
    id: 'mip-li-10',
    invoice_id: 'mip-inv-6',
    description: 'Vehicle Magnets - 12x24',
    quantity: 4,
    price: 45,
    job_cost: 18,
    is_taxable: true,
    profit_margin: calculateProfitMargin(45, 18),
  },
  // Invoice 7 - draft
  {
    id: 'mip-li-11',
    invoice_id: 'mip-inv-7',
    description: 'Appointment Cards',
    quantity: 1000,
    price: 0.06,
    job_cost: 0.02,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.06, 0.02),
  },
  {
    id: 'mip-li-12',
    invoice_id: 'mip-inv-7',
    description: 'Referral Cards',
    quantity: 500,
    price: 0.08,
    job_cost: 0.03,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.08, 0.03),
  },
  // Invoice 8 - draft
  {
    id: 'mip-li-13',
    invoice_id: 'mip-inv-8',
    description: 'Window Decals - Custom',
    quantity: 6,
    price: 25,
    job_cost: 10,
    is_taxable: true,
    profit_margin: calculateProfitMargin(25, 10),
  },
  // Invoice 9 - refunded
  {
    id: 'mip-li-14',
    invoice_id: 'mip-inv-9',
    description: 'Posters - 24x36',
    quantity: 20,
    price: 12,
    job_cost: 5,
    is_taxable: true,
    profit_margin: calculateProfitMargin(12, 5),
  },
  // Invoice 10 - voided
  {
    id: 'mip-li-15',
    invoice_id: 'mip-inv-10',
    description: 'Stickers - 2x2 Circle',
    quantity: 500,
    price: 0.1,
    job_cost: 0.03,
    is_taxable: true,
    profit_margin: calculateProfitMargin(0.1, 0.03),
  },
]

// Storm Taekwondo Line Items (classes are NOT taxable, products ARE taxable)
const stLineItems: LineItem[] = [
  // Invoice 1 - paid
  {
    id: 'st-li-1',
    invoice_id: 'st-inv-1',
    description: 'Monthly Classes - Adult',
    quantity: 1,
    price: 150,
    job_cost: 50,
    is_taxable: false,
    profit_margin: calculateProfitMargin(150, 50),
  },
  {
    id: 'st-li-2',
    invoice_id: 'st-inv-1',
    description: 'Uniform - Adult Size',
    quantity: 1,
    price: 75,
    job_cost: 30,
    is_taxable: true,
    profit_margin: calculateProfitMargin(75, 30),
  },
  // Invoice 2 - paid
  {
    id: 'st-li-3',
    invoice_id: 'st-inv-2',
    description: 'Monthly Classes - Child',
    quantity: 2,
    price: 120,
    job_cost: 40,
    is_taxable: false,
    profit_margin: calculateProfitMargin(120, 40),
  },
  // Invoice 3 - paid
  {
    id: 'st-li-4',
    invoice_id: 'st-inv-3',
    description: 'Monthly Classes - Family Package',
    quantity: 1,
    price: 350,
    job_cost: 120,
    is_taxable: false,
    profit_margin: calculateProfitMargin(350, 120),
  },
  {
    id: 'st-li-5',
    invoice_id: 'st-inv-3',
    description: 'Belt Testing Fee',
    quantity: 2,
    price: 50,
    job_cost: 15,
    is_taxable: false,
    profit_margin: calculateProfitMargin(50, 15),
  },
  // Invoice 4 - sent
  {
    id: 'st-li-6',
    invoice_id: 'st-inv-4',
    description: 'Monthly Classes - Adult',
    quantity: 1,
    price: 150,
    job_cost: 50,
    is_taxable: false,
    profit_margin: calculateProfitMargin(150, 50),
  },
  {
    id: 'st-li-7',
    invoice_id: 'st-inv-4',
    description: 'Sparring Gear Set',
    quantity: 1,
    price: 120,
    job_cost: 60,
    is_taxable: true,
    profit_margin: calculateProfitMargin(120, 60),
  },
  // Invoice 5 - sent
  {
    id: 'st-li-8',
    invoice_id: 'st-inv-5',
    description: 'Monthly Classes - Child',
    quantity: 1,
    price: 120,
    job_cost: 40,
    is_taxable: false,
    profit_margin: calculateProfitMargin(120, 40),
  },
  // Invoice 6 - sent
  {
    id: 'st-li-9',
    invoice_id: 'st-inv-6',
    description: 'Private Lesson (1 hour)',
    quantity: 4,
    price: 75,
    job_cost: 25,
    is_taxable: false,
    profit_margin: calculateProfitMargin(75, 25),
  },
  // Invoice 7 - draft
  {
    id: 'st-li-10',
    invoice_id: 'st-inv-7',
    description: 'Monthly Classes - Adult',
    quantity: 1,
    price: 150,
    job_cost: 50,
    is_taxable: false,
    profit_margin: calculateProfitMargin(150, 50),
  },
  {
    id: 'st-li-11',
    invoice_id: 'st-inv-7',
    description: 'Uniform - Child Size',
    quantity: 1,
    price: 60,
    job_cost: 25,
    is_taxable: true,
    profit_margin: calculateProfitMargin(60, 25),
  },
  // Invoice 8 - draft
  {
    id: 'st-li-12',
    invoice_id: 'st-inv-8',
    description: 'Summer Camp Registration',
    quantity: 1,
    price: 250,
    job_cost: 80,
    is_taxable: false,
    profit_margin: calculateProfitMargin(250, 80),
  },
  // Invoice 9 - refunded
  {
    id: 'st-li-13',
    invoice_id: 'st-inv-9',
    description: 'Tournament Registration',
    quantity: 2,
    price: 85,
    job_cost: 40,
    is_taxable: false,
    profit_margin: calculateProfitMargin(85, 40),
  },
  // Invoice 10 - voided
  {
    id: 'st-li-14',
    invoice_id: 'st-inv-10',
    description: 'Training Equipment Bundle',
    quantity: 1,
    price: 95,
    job_cost: 45,
    is_taxable: true,
    profit_margin: calculateProfitMargin(95, 45),
  },
]

export const lineItems: LineItem[] = [
  ...wfLineItems,
  ...mipLineItems,
  ...stLineItems,
]

// Helper to calculate invoice totals
function calcInvoiceTotals(
  invoiceLineItems: LineItem[],
  shippingCharge: number = 0,
  discount: number = 0,
) {
  const subtotal = invoiceLineItems.reduce(
    (sum, li) => sum + li.quantity * li.price,
    0,
  )
  const taxableAmount = invoiceLineItems
    .filter((li) => li.is_taxable)
    .reduce((sum, li) => sum + li.quantity * li.price, 0)
  const taxAmount = Math.round(taxableAmount * 0.06 * 100) / 100
  const total =
    Math.round((subtotal + shippingCharge + taxAmount - discount) * 100) / 100
  return { subtotal, taxAmount, total }
}

// WebsiteForge Invoices
const wfInv1Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-1'),
)
const wfInv2Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-2'),
  25,
)
const wfInv3Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-3'),
)
const wfInv4Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-4'),
)
const wfInv5Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-5'),
)
const wfInv6Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-6'),
)
const wfInv7Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-7'),
)
const wfInv8Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-8'),
)
const wfInv9Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-9'),
)
const wfInv10Totals = calcInvoiceTotals(
  wfLineItems.filter((li) => li.invoice_id === 'wf-inv-10'),
)

const wfInvoices: Invoice[] = [
  {
    id: 'wf-inv-1',
    company_id: 'wf',
    customer_id: 'wf-cust-1',
    date: new Date('2025-12-01'),
    status: 'paid',
    subtotal: wfInv1Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv1Totals.taxAmount,
    total_amount: wfInv1Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-2',
    company_id: 'wf',
    customer_id: 'wf-cust-2',
    date: new Date('2025-11-28'),
    status: 'paid',
    subtotal: wfInv2Totals.subtotal,
    shipping_charge: 25,
    tax_rate: 0.06,
    tax_amount: wfInv2Totals.taxAmount,
    total_amount: wfInv2Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-3',
    company_id: 'wf',
    customer_id: 'wf-cust-3',
    date: new Date('2025-11-25'),
    status: 'paid',
    subtotal: wfInv3Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv3Totals.taxAmount,
    total_amount: wfInv3Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-4',
    company_id: 'wf',
    customer_id: 'wf-cust-1',
    date: new Date('2025-12-05'),
    status: 'sent',
    subtotal: wfInv4Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv4Totals.taxAmount,
    total_amount: wfInv4Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-5',
    company_id: 'wf',
    customer_id: 'wf-cust-4',
    date: new Date('2025-12-06'),
    status: 'sent',
    subtotal: wfInv5Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv5Totals.taxAmount,
    total_amount: wfInv5Totals.total,
    created_by: 'admin',
    sent_via_email: true,
    sent_via_sms: true,
  },
  {
    id: 'wf-inv-6',
    company_id: 'wf',
    customer_id: 'wf-cust-5',
    date: new Date('2025-12-07'),
    status: 'sent',
    subtotal: wfInv6Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv6Totals.taxAmount,
    total_amount: wfInv6Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-7',
    company_id: 'wf',
    customer_id: 'wf-cust-3',
    date: new Date('2025-12-08'),
    status: 'draft',
    subtotal: wfInv7Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv7Totals.taxAmount,
    total_amount: wfInv7Totals.total,
    created_by: 'admin',
  },
  {
    id: 'wf-inv-8',
    company_id: 'wf',
    customer_id: 'wf-cust-2',
    date: new Date('2025-12-09'),
    status: 'draft',
    subtotal: wfInv8Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv8Totals.taxAmount,
    total_amount: wfInv8Totals.total,
    created_by: 'admin',
  },
  {
    id: 'wf-inv-9',
    company_id: 'wf',
    customer_id: 'wf-cust-4',
    date: new Date('2025-11-20'),
    status: 'refunded',
    subtotal: wfInv9Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv9Totals.taxAmount,
    total_amount: wfInv9Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'wf-inv-10',
    company_id: 'wf',
    customer_id: 'wf-cust-5',
    date: new Date('2025-11-15'),
    status: 'voided',
    subtotal: wfInv10Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: wfInv10Totals.taxAmount,
    total_amount: wfInv10Totals.total,
    created_by: 'admin',
  },
]

// MIP Invoices
const mipInv1Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-1'),
)
const mipInv2Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-2'),
)
const mipInv3Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-3'),
)
const mipInv4Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-4'),
)
const mipInv5Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-5'),
)
const mipInv6Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-6'),
)
const mipInv7Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-7'),
)
const mipInv8Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-8'),
)
const mipInv9Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-9'),
)
const mipInv10Totals = calcInvoiceTotals(
  mipLineItems.filter((li) => li.invoice_id === 'mip-inv-10'),
)

const mipInvoices: Invoice[] = [
  {
    id: 'mip-inv-1',
    company_id: 'mip',
    customer_id: 'mip-cust-1',
    date: new Date('2025-12-02'),
    status: 'paid',
    subtotal: mipInv1Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv1Totals.taxAmount,
    total_amount: mipInv1Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-2',
    company_id: 'mip',
    customer_id: 'mip-cust-2',
    date: new Date('2025-11-30'),
    status: 'paid',
    subtotal: mipInv2Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv2Totals.taxAmount,
    total_amount: mipInv2Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-3',
    company_id: 'mip',
    customer_id: 'mip-cust-3',
    date: new Date('2025-11-27'),
    status: 'paid',
    subtotal: mipInv3Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv3Totals.taxAmount,
    total_amount: mipInv3Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-4',
    company_id: 'mip',
    customer_id: 'mip-cust-2',
    date: new Date('2025-12-04'),
    status: 'sent',
    subtotal: mipInv4Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv4Totals.taxAmount,
    total_amount: mipInv4Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-5',
    company_id: 'mip',
    customer_id: 'mip-cust-3',
    date: new Date('2025-12-05'),
    status: 'sent',
    subtotal: mipInv5Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv5Totals.taxAmount,
    total_amount: mipInv5Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-6',
    company_id: 'mip',
    customer_id: 'mip-cust-4',
    date: new Date('2025-12-06'),
    status: 'sent',
    subtotal: mipInv6Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv6Totals.taxAmount,
    total_amount: mipInv6Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-7',
    company_id: 'mip',
    customer_id: 'mip-cust-5',
    date: new Date('2025-12-08'),
    status: 'draft',
    subtotal: mipInv7Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv7Totals.taxAmount,
    total_amount: mipInv7Totals.total,
    created_by: 'admin',
  },
  {
    id: 'mip-inv-8',
    company_id: 'mip',
    customer_id: 'mip-cust-4',
    date: new Date('2025-12-09'),
    status: 'draft',
    subtotal: mipInv8Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv8Totals.taxAmount,
    total_amount: mipInv8Totals.total,
    created_by: 'admin',
  },
  {
    id: 'mip-inv-9',
    company_id: 'mip',
    customer_id: 'mip-cust-1',
    date: new Date('2025-11-18'),
    status: 'refunded',
    subtotal: mipInv9Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv9Totals.taxAmount,
    total_amount: mipInv9Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'mip-inv-10',
    company_id: 'mip',
    customer_id: 'mip-cust-5',
    date: new Date('2025-11-10'),
    status: 'voided',
    subtotal: mipInv10Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: mipInv10Totals.taxAmount,
    total_amount: mipInv10Totals.total,
    created_by: 'admin',
  },
]

// Storm Taekwondo Invoices
const stInv1Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-1'),
)
const stInv2Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-2'),
)
const stInv3Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-3'),
)
const stInv4Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-4'),
)
const stInv5Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-5'),
)
const stInv6Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-6'),
)
const stInv7Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-7'),
)
const stInv8Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-8'),
)
const stInv9Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-9'),
)
const stInv10Totals = calcInvoiceTotals(
  stLineItems.filter((li) => li.invoice_id === 'st-inv-10'),
)

const stInvoices: Invoice[] = [
  {
    id: 'st-inv-1',
    company_id: 'st',
    customer_id: 'st-cust-1',
    date: new Date('2025-12-01'),
    status: 'paid',
    subtotal: stInv1Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv1Totals.taxAmount,
    total_amount: stInv1Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-2',
    company_id: 'st',
    customer_id: 'st-cust-2',
    date: new Date('2025-11-29'),
    status: 'paid',
    subtotal: stInv2Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv2Totals.taxAmount,
    total_amount: stInv2Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-3',
    company_id: 'st',
    customer_id: 'st-cust-3',
    date: new Date('2025-11-26'),
    status: 'paid',
    subtotal: stInv3Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv3Totals.taxAmount,
    total_amount: stInv3Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-4',
    company_id: 'st',
    customer_id: 'st-cust-2',
    date: new Date('2025-12-03'),
    status: 'sent',
    subtotal: stInv4Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv4Totals.taxAmount,
    total_amount: stInv4Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-5',
    company_id: 'st',
    customer_id: 'st-cust-4',
    date: new Date('2025-12-05'),
    status: 'sent',
    subtotal: stInv5Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv5Totals.taxAmount,
    total_amount: stInv5Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-6',
    company_id: 'st',
    customer_id: 'st-cust-1',
    date: new Date('2025-12-07'),
    status: 'sent',
    subtotal: stInv6Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv6Totals.taxAmount,
    total_amount: stInv6Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-7',
    company_id: 'st',
    customer_id: 'st-cust-5',
    date: new Date('2025-12-08'),
    status: 'draft',
    subtotal: stInv7Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv7Totals.taxAmount,
    total_amount: stInv7Totals.total,
    created_by: 'admin',
  },
  {
    id: 'st-inv-8',
    company_id: 'st',
    customer_id: 'st-cust-3',
    date: new Date('2025-12-09'),
    status: 'draft',
    subtotal: stInv8Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv8Totals.taxAmount,
    total_amount: stInv8Totals.total,
    created_by: 'admin',
  },
  {
    id: 'st-inv-9',
    company_id: 'st',
    customer_id: 'st-cust-4',
    date: new Date('2025-11-22'),
    status: 'refunded',
    subtotal: stInv9Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv9Totals.taxAmount,
    total_amount: stInv9Totals.total,
    created_by: 'admin',
    sent_via_email: true,
  },
  {
    id: 'st-inv-10',
    company_id: 'st',
    customer_id: 'st-cust-5',
    date: new Date('2025-11-12'),
    status: 'voided',
    subtotal: stInv10Totals.subtotal,
    tax_rate: 0.06,
    tax_amount: stInv10Totals.taxAmount,
    total_amount: stInv10Totals.total,
    created_by: 'admin',
  },
]

export const invoices: Invoice[] = [
  ...wfInvoices,
  ...mipInvoices,
  ...stInvoices,
]

// Subscriptions
const wfSubscriptions: Subscription[] = [
  {
    id: 'wf-sub-1',
    company_id: 'wf',
    customer_id: 'wf-cust-1',
    start_date: new Date('2025-11-01'),
    next_billing_date: new Date('2025-12-10'),
    last_billed_date: new Date('2025-11-10'),
    cycle_days: 30,
    payment_method_id: 'pm_web1',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'wf-sub-2',
    company_id: 'wf',
    customer_id: 'wf-cust-2',
    start_date: new Date('2025-10-15'),
    next_billing_date: new Date('2025-12-14'),
    last_billed_date: new Date('2025-11-14'),
    cycle_days: 30,
    payment_method_id: 'pm_web2',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'wf-sub-3',
    company_id: 'wf',
    customer_id: 'wf-cust-3',
    start_date: new Date('2025-09-01'),
    next_billing_date: new Date('2025-12-11'),
    last_billed_date: new Date('2025-11-11'),
    cycle_days: 30,
    payment_method_id: 'pm_web3',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'wf-sub-4',
    company_id: 'wf',
    customer_id: 'wf-cust-4',
    start_date: new Date('2025-08-01'),
    end_date: new Date('2025-11-30'),
    next_billing_date: new Date('2025-12-01'),
    last_billed_date: new Date('2025-11-01'),
    cycle_days: 30,
    terms_accepted: true,
    status: 'canceled',
  },
  {
    id: 'wf-sub-5',
    company_id: 'wf',
    customer_id: 'wf-cust-5',
    start_date: new Date('2025-11-15'),
    next_billing_date: new Date('2025-12-15'),
    last_billed_date: new Date('2025-11-15'),
    cycle_days: 30,
    payment_method_id: 'pm_web5',
    terms_accepted: true,
    status: 'paused',
  },
]

const mipSubscriptions: Subscription[] = [
  {
    id: 'mip-sub-1',
    company_id: 'mip',
    customer_id: 'mip-cust-1',
    start_date: new Date('2025-09-01'),
    next_billing_date: new Date('2025-12-12'),
    last_billed_date: new Date('2025-09-12'),
    cycle_days: 90,
    payment_method_id: 'pm_print1',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'mip-sub-2',
    company_id: 'mip',
    customer_id: 'mip-cust-2',
    start_date: new Date('2025-06-15'),
    next_billing_date: new Date('2025-12-15'),
    last_billed_date: new Date('2025-09-15'),
    cycle_days: 90,
    payment_method_id: 'pm_print2',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'mip-sub-3',
    company_id: 'mip',
    customer_id: 'mip-cust-3',
    start_date: new Date('2025-10-01'),
    next_billing_date: new Date('2026-01-01'),
    last_billed_date: new Date('2025-10-01'),
    cycle_days: 90,
    payment_method_id: 'pm_print3',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'mip-sub-4',
    company_id: 'mip',
    customer_id: 'mip-cust-4',
    start_date: new Date('2025-03-01'),
    end_date: new Date('2025-09-01'),
    next_billing_date: new Date('2025-09-01'),
    last_billed_date: new Date('2025-06-01'),
    cycle_days: 90,
    terms_accepted: true,
    status: 'canceled',
  },
  {
    id: 'mip-sub-5',
    company_id: 'mip',
    customer_id: 'mip-cust-5',
    start_date: new Date('2025-07-01'),
    next_billing_date: new Date('2025-12-28'),
    last_billed_date: new Date('2025-09-28'),
    cycle_days: 90,
    payment_method_id: 'pm_print5',
    terms_accepted: true,
    status: 'paused',
  },
]

const stSubscriptions: Subscription[] = [
  {
    id: 'st-sub-1',
    company_id: 'st',
    customer_id: 'st-cust-1',
    start_date: new Date('2025-10-01'),
    next_billing_date: new Date('2025-12-10'),
    last_billed_date: new Date('2025-11-10'),
    cycle_days: 30,
    payment_method_id: 'pm_taek1',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'st-sub-2',
    company_id: 'st',
    customer_id: 'st-cust-2',
    start_date: new Date('2025-09-15'),
    next_billing_date: new Date('2025-12-15'),
    last_billed_date: new Date('2025-11-15'),
    cycle_days: 30,
    payment_method_id: 'pm_taek2',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'st-sub-3',
    company_id: 'st',
    customer_id: 'st-cust-3',
    start_date: new Date('2025-08-01'),
    next_billing_date: new Date('2025-12-11'),
    last_billed_date: new Date('2025-11-11'),
    cycle_days: 30,
    payment_method_id: 'pm_taek3',
    terms_accepted: true,
    status: 'active',
  },
  {
    id: 'st-sub-4',
    company_id: 'st',
    customer_id: 'st-cust-4',
    start_date: new Date('2025-06-01'),
    end_date: new Date('2025-10-31'),
    next_billing_date: new Date('2025-11-01'),
    last_billed_date: new Date('2025-10-01'),
    cycle_days: 30,
    terms_accepted: true,
    status: 'canceled',
  },
  {
    id: 'st-sub-5',
    company_id: 'st',
    customer_id: 'st-cust-5',
    start_date: new Date('2025-11-01'),
    next_billing_date: new Date('2025-12-12'),
    last_billed_date: new Date('2025-11-12'),
    cycle_days: 30,
    payment_method_id: 'pm_taek5',
    terms_accepted: true,
    status: 'paused',
  },
]

export const subscriptions: Subscription[] = [
  ...wfSubscriptions,
  ...mipSubscriptions,
  ...stSubscriptions,
]

// Payments
const wfPayments: Payment[] = [
  {
    id: 'wf-pay-1',
    invoice_id: 'wf-inv-1',
    amount: wfInv1Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-12-02'),
    stripe_fee: calculateStripeFee(wfInv1Totals.total),
    net_amount: calculateNetAmount(
      wfInv1Totals.total,
      calculateStripeFee(wfInv1Totals.total),
    ),
  },
  {
    id: 'wf-pay-2',
    invoice_id: 'wf-inv-2',
    amount: wfInv2Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-29'),
    stripe_fee: calculateStripeFee(wfInv2Totals.total),
    net_amount: calculateNetAmount(
      wfInv2Totals.total,
      calculateStripeFee(wfInv2Totals.total),
    ),
  },
  {
    id: 'wf-pay-3',
    invoice_id: 'wf-inv-3',
    amount: wfInv3Totals.total,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-26'),
    net_amount: wfInv3Totals.total,
  },
  {
    id: 'wf-pay-4',
    invoice_id: 'wf-inv-9',
    amount: wfInv9Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-21'),
    stripe_fee: calculateStripeFee(wfInv9Totals.total),
    net_amount: calculateNetAmount(
      wfInv9Totals.total,
      calculateStripeFee(wfInv9Totals.total),
    ),
  },
  {
    id: 'wf-pay-5',
    invoice_id: 'wf-inv-1',
    amount: 100,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-15'),
    stripe_fee: calculateStripeFee(100),
    net_amount: calculateNetAmount(100, calculateStripeFee(100)),
  },
  {
    id: 'wf-pay-6',
    invoice_id: 'wf-inv-2',
    amount: 500,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-20'),
    stripe_fee: calculateStripeFee(500),
    net_amount: calculateNetAmount(500, calculateStripeFee(500)),
  },
  {
    id: 'wf-pay-7',
    invoice_id: 'wf-inv-3',
    amount: 200,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-22'),
    net_amount: 200,
  },
  {
    id: 'wf-pay-8',
    invoice_id: 'wf-inv-4',
    amount: 50,
    method: 'stripe',
    status: 'pending',
    date: new Date('2025-12-08'),
    stripe_fee: calculateStripeFee(50),
    net_amount: calculateNetAmount(50, calculateStripeFee(50)),
  },
]

const mipPayments: Payment[] = [
  {
    id: 'mip-pay-1',
    invoice_id: 'mip-inv-1',
    amount: mipInv1Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-12-03'),
    stripe_fee: calculateStripeFee(mipInv1Totals.total),
    net_amount: calculateNetAmount(
      mipInv1Totals.total,
      calculateStripeFee(mipInv1Totals.total),
    ),
  },
  {
    id: 'mip-pay-2',
    invoice_id: 'mip-inv-2',
    amount: mipInv2Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-12-01'),
    stripe_fee: calculateStripeFee(mipInv2Totals.total),
    net_amount: calculateNetAmount(
      mipInv2Totals.total,
      calculateStripeFee(mipInv2Totals.total),
    ),
  },
  {
    id: 'mip-pay-3',
    invoice_id: 'mip-inv-3',
    amount: mipInv3Totals.total,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-28'),
    net_amount: mipInv3Totals.total,
  },
  {
    id: 'mip-pay-4',
    invoice_id: 'mip-inv-9',
    amount: mipInv9Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-19'),
    stripe_fee: calculateStripeFee(mipInv9Totals.total),
    net_amount: calculateNetAmount(
      mipInv9Totals.total,
      calculateStripeFee(mipInv9Totals.total),
    ),
  },
  {
    id: 'mip-pay-5',
    invoice_id: 'mip-inv-1',
    amount: 50,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-25'),
    stripe_fee: calculateStripeFee(50),
    net_amount: calculateNetAmount(50, calculateStripeFee(50)),
  },
  {
    id: 'mip-pay-6',
    invoice_id: 'mip-inv-2',
    amount: 75,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-27'),
    stripe_fee: calculateStripeFee(75),
    net_amount: calculateNetAmount(75, calculateStripeFee(75)),
  },
  {
    id: 'mip-pay-7',
    invoice_id: 'mip-inv-3',
    amount: 100,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-26'),
    net_amount: 100,
  },
  {
    id: 'mip-pay-8',
    invoice_id: 'mip-inv-4',
    amount: 25,
    method: 'stripe',
    status: 'pending',
    date: new Date('2025-12-07'),
    stripe_fee: calculateStripeFee(25),
    net_amount: calculateNetAmount(25, calculateStripeFee(25)),
  },
]

const stPayments: Payment[] = [
  {
    id: 'st-pay-1',
    invoice_id: 'st-inv-1',
    amount: stInv1Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-12-02'),
    stripe_fee: calculateStripeFee(stInv1Totals.total),
    net_amount: calculateNetAmount(
      stInv1Totals.total,
      calculateStripeFee(stInv1Totals.total),
    ),
  },
  {
    id: 'st-pay-2',
    invoice_id: 'st-inv-2',
    amount: stInv2Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-30'),
    stripe_fee: calculateStripeFee(stInv2Totals.total),
    net_amount: calculateNetAmount(
      stInv2Totals.total,
      calculateStripeFee(stInv2Totals.total),
    ),
  },
  {
    id: 'st-pay-3',
    invoice_id: 'st-inv-3',
    amount: stInv3Totals.total,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-27'),
    net_amount: stInv3Totals.total,
  },
  {
    id: 'st-pay-4',
    invoice_id: 'st-inv-9',
    amount: stInv9Totals.total,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-23'),
    stripe_fee: calculateStripeFee(stInv9Totals.total),
    net_amount: calculateNetAmount(
      stInv9Totals.total,
      calculateStripeFee(stInv9Totals.total),
    ),
  },
  {
    id: 'st-pay-5',
    invoice_id: 'st-inv-1',
    amount: 50,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-20'),
    stripe_fee: calculateStripeFee(50),
    net_amount: calculateNetAmount(50, calculateStripeFee(50)),
  },
  {
    id: 'st-pay-6',
    invoice_id: 'st-inv-2',
    amount: 60,
    method: 'stripe',
    status: 'succeeded',
    date: new Date('2025-11-25'),
    stripe_fee: calculateStripeFee(60),
    net_amount: calculateNetAmount(60, calculateStripeFee(60)),
  },
  {
    id: 'st-pay-7',
    invoice_id: 'st-inv-3',
    amount: 100,
    method: 'cash',
    status: 'succeeded',
    date: new Date('2025-11-24'),
    net_amount: 100,
  },
  {
    id: 'st-pay-8',
    invoice_id: 'st-inv-4',
    amount: 75,
    method: 'stripe',
    status: 'pending',
    date: new Date('2025-12-06'),
    stripe_fee: calculateStripeFee(75),
    net_amount: calculateNetAmount(75, calculateStripeFee(75)),
  },
]

export const payments: Payment[] = [
  ...wfPayments,
  ...mipPayments,
  ...stPayments,
]

// Refunds
const wfRefunds: Refund[] = [
  {
    id: 'wf-ref-1',
    invoice_id: 'wf-inv-9',
    amount: 100,
    reason: 'Service not as described',
    date: new Date('2025-12-05'),
  },
  {
    id: 'wf-ref-2',
    invoice_id: 'wf-inv-1',
    amount: 50,
    reason: 'Partial refund - feature removed',
    date: new Date('2025-12-03'),
  },
  {
    id: 'wf-ref-3',
    invoice_id: 'wf-inv-2',
    amount: 25,
    reason: 'Overcharge on shipping',
    date: new Date('2025-12-01'),
  },
]

const mipRefunds: Refund[] = [
  {
    id: 'mip-ref-1',
    invoice_id: 'mip-inv-9',
    amount: 50,
    reason: 'Print quality issue',
    date: new Date('2025-12-04'),
  },
  {
    id: 'mip-ref-2',
    invoice_id: 'mip-inv-1',
    amount: 20,
    reason: 'Quantity error',
    date: new Date('2025-12-06'),
  },
  {
    id: 'mip-ref-3',
    invoice_id: 'mip-inv-2',
    amount: 15,
    reason: 'Late delivery compensation',
    date: new Date('2025-12-02'),
  },
]

const stRefunds: Refund[] = [
  {
    id: 'st-ref-1',
    invoice_id: 'st-inv-9',
    amount: 85,
    reason: 'Tournament canceled',
    date: new Date('2025-12-03'),
  },
  {
    id: 'st-ref-2',
    invoice_id: 'st-inv-1',
    amount: 30,
    reason: 'Class schedule conflict',
    date: new Date('2025-12-05'),
  },
  {
    id: 'st-ref-3',
    invoice_id: 'st-inv-3',
    amount: 50,
    reason: 'Belt testing postponed',
    date: new Date('2025-12-01'),
  },
]

export const refunds: Refund[] = [...wfRefunds, ...mipRefunds, ...stRefunds]

export const seedData = {
  companies,
  customers,
  invoices,
  lineItems,
  subscriptions,
  payments,
  refunds,
}
